import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

declare global {
  interface Window {
    notyf: any;
  }
}

/**
 * From AppStack bootstrap theme, we are using Notyf for status messages.
 */
@Injectable({
  providedIn: 'root'
})
export class NotyfService {
  /**
   * Main notyf method.
   * @param message Message to display
   * @param type success | error | warning
   */
  public notify(message: string, type: string) { 
    window.notyf.open({
      type: type,
      dismissible: true,
      message: message,
      duration: 4500,
      ripple: true,
      position: {
        x: 'right',
        y: 'top'
      }
    });
  }

  /**
   * Display success message
   * @param message 
   */
  public notifySuccess(message: string) {
    this.notify(message, 'success');
  }

  /**
   * Display error message
   * @param message 
   */
  public notifyError(message: string) {
    this.notify(message, 'error');
  }

  /**
   * Display warning message
   * @param message 
   */
  public notifyWarning(message: string) {
    this.notify(message, 'warning');
  }

  public swalBox (options: {
    title?: string,
    text?: string,
    html?: string,
    icon?: 'success' | 'error' | 'warning' | 'info' | 'question',
    allowedOutsideClick?: boolean,
    allowEscapeKey?: boolean,
    width?: string,
    position?: 'top' | 'top-start' | 'top-end' | 'top-left' | 'top-right' | 'center' | 'center-start' | 'center-end' | 'center-left' | 'center-right' | 'bottom' | 'bottom-start' | 'bottom-end' | 'bottom-left' | 'bottom-right',
    confirmButtonText?: string,
    cancelButtonText?: string,
    showCancelButton?: boolean,
    cancelButtonColor?: string,
    confirmButtonColor?: string,
    focusCancel?: boolean
  }, isUseHtml: boolean = false) {
    const config = {
      title: options.title,
      text: options.text,
      html: options.html,
      icon: options.icon ?? 'success',
      allowOutsideClick: options.allowedOutsideClick ?? false,
      allowEscapeKey: options.allowEscapeKey ?? false,
      width: options.width ?? '30em',
      position: options.position ?? 'top',
      confirmButtonText: options.confirmButtonText ?? 'Proceed',
      cancelButtonText: options.cancelButtonText ?? 'Cancel',
      showCancelButton: options.showCancelButton ?? true,
      cancelButtonColor: options.cancelButtonColor ?? '#e97474',
      confirmButtonColor: options.confirmButtonColor ?? '#2a6af6',
      focusCancel: options.focusCancel ?? false
    };
    if (isUseHtml) delete config.text;
    if (!isUseHtml) delete config.html;
    return Swal.fire(config)
  }
}